define('loader',["exports", "nprogress"], function (_exports, _nprogress) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.disableLoader = disableLoader;
  _exports.enableLoader = enableLoader;
  _exports.isLoading = isLoading;
  _exports.loaderDisabled = loaderDisabled;
  _exports.startLoader = startLoader;
  _exports.stopLoader = stopLoader;
  _exports.task = task;
  _nprogress = _interopRequireDefault(_nprogress);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var count = 0;
  var disabled = false;
  function startLoader() {
    if (count === 0) {
      _nprogress.default.start();
    }
    count++;
  }
  function stopLoader() {
    if (count === 0) {
      return;
    }
    count--;
    if (count === 0) {
      _nprogress.default.done();
    }
  }
  function disableLoader() {
    disabled = true;
  }
  function enableLoader() {
    disabled = false;
  }
  function isLoading() {
    return count > 0;
  }
  function loaderDisabled() {
    return disabled;
  }
  async function task(t) {
    startLoader();
    try {
      return await t();
    } finally {
      stopLoader();
    }
  }
});//# sourceMappingURL=loader.js.map
;
